import React, { ForwardedRef } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import cn from 'classnames'

import { Avatar } from './Avatar'

interface AvatarButtonProps {
  className?: string
  src: string
  alt?: string
  callback?: () => void
  rank?: number
  isPermanentBan?: boolean
}

interface UserAvatarProps extends AvatarButtonProps {
  slug: string
}

const AvatarButton = React.forwardRef<HTMLAnchorElement, AvatarButtonProps>(
  (
    { onClick, href, src, alt, callback, className, rank, isPermanentBan }: any,
    ref: ForwardedRef<HTMLAnchorElement>
  ) => {
    return (
      <div className={cn('relative cursor-pointer', className)}>
        <a
          ref={ref}
          href={href}
          onClick={event => {
            onClick(event)

            if (callback) {
              callback()
            }
          }}
        >
          {src && !isPermanentBan ? (
            <div className='relative w-full h-full'>
              <Image
                className='rounded-full object-cover'
                src={src}
                layout='fill'
                alt={alt}
                quality={25}
                sizes='(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw'
              />
            </div>
          ) : (
            <Avatar className='w-full h-full' src='/images/avatar.png' />
          )}
        </a>
      </div>
    )
  }
)

export function UserAvatar({ slug, ...props }: UserAvatarProps) {
  return (
    <Link href={`/profile/${slug}`} passHref prefetch={false}>
      <AvatarButton {...props} />
    </Link>
  )
}
